import React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import "./usersReviews.css";
import VideoComponent from "../s3-video/video";

const UserReview = ({ node }) => {
  const {
    reviewTitle,
    reviewTitleColor,
    reviewUserName,
    reviewUserColor,
    review,
    starsRating,
    ctaLink,
    reviewImage,
    reviewVideo,
  } = node;
  let starsSrcImg = "";
  // let reviewImg = "";
  // if (reviewImage && reviewImage.asset) {
  //   reviewImg = reviewImage.asset.url;
  // }

  let reviewImg = [];
  let index = 0;
  if (reviewImage && typeof reviewImage !== "undefined") {
    for (const img of reviewImage) {
      if (img && img.asset) {
        reviewImg[index] = img.asset.url;
        index++;
      }
    }
  }

  switch (starsRating) {
    case "3":
      starsSrcImg = "/rating/3_star.png";
      break;
    case "3.5":
      starsSrcImg = "/rating/3_and_half_star.png";
      break;
    case "4.5":
      starsSrcImg = "/rating/4_and_half.png";
      break;
    case "5":
      starsSrcImg = "/rating/5_star.png";
      break;
    default:
      starsSrcImg = "/rating/4_star.png";
  }
  return (
    <Box className="reviewDiv">
      <Box mb={2}>
        <Grid container>
          <Grid>
            <Box mb={2}>
              <h3 style={{ color: reviewTitleColor }} className="head">
                {reviewTitle}
              </h3>
            </Box>
            <Box>
              <Typography
                className="reviewText"
                dangerouslySetInnerHTML={{ __html: review }}
              />

              {reviewImg && reviewImg.length > 0
                ? reviewImg.map((item) => {
                    return <img src={item} width={"198px"} height={"198px"} />;
                  })
                : null}

              {reviewVideo && reviewVideo.length > 0
                ? reviewVideo.map((item) => {
                    return (
                      <VideoComponent
                        node={{ video: item }}
                        width="198px"
                        // height="198px"
                        iconFont="30px"
                        iconPositionTop="40%"
                        iconPositionLeft="40%"
                      />
                    );
                  })
                : null}
            </Box>
          </Grid>
        </Grid>
      </Box>
      <Box>
        <Grid container alignItems={"flex-end"}>
          <Grid item xs={6} sm={6} md={6}>
            <h4 style={{ color: reviewUserColor }} className="userName">
              {reviewUserName}
            </h4>
            <img src={starsSrcImg} className="starsRatingImg" />
            <a href={ctaLink} className="verifiedUserLink">
              Verified Buyer
            </a>
          </Grid>
          <Grid item xs={3} sm={3} md={3}></Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default UserReview;
